module.exports = __webpack_public_path__ + "static/media/dustBin.81b34c23.svg";